import { useTranslation } from "react-i18next";
import React from "react";
import TaskList from "../components/TaskList";
import Loader from "../../../../components/Common/loader";
import { formatToFrenchDate } from "../../../../utils/dateUtils";
import NoDataComponent from "components/Common/NoData";
import { ClassTask } from "types/classTaskTypes";

interface TaskListCardProps {
  selectedDate: string | null;
  tasks: any[];
  loading: boolean;
  error: string | null;
  onTaskClick: (task: any) => void;
  onShowAttachments?:(task: ClassTask) => void;
}

const TaskListCard: React.FC<TaskListCardProps> = ({ selectedDate, tasks, loading, error, onTaskClick, onShowAttachments }) => {
  const { t } = useTranslation();
  return (
    <div>
      {loading && <Loader />}
      {error && <p className="text-danger">{error}</p>}
      {!loading && !error && (
        <TaskList tasks={tasks} onTaskClick={onTaskClick} onShowAttachments={onShowAttachments} />
      )}
    </div>
  );
};

export default TaskListCard;
